import styled, { css } from 'styled-components';

import { media } from '@simplywallst/ui-core';

const column1CSS = css`
  width: 100px;

  ${media.smUp`
    width: 120px;
  `}
`;

const column2CSS = css`
  width: 120px;

  ${media.smUp`
    width: 160px;
  `}
`;

const column3CSS = css`
  width: 160px;
`;

interface Props {
  isHoldingComplete?: boolean;
}

export const TableCell = styled('td')<Props>`
  white-space: nowrap;
  border-right: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
  border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
  color: ${({ theme }) => theme.color.white};

  &:first-child {
    max-width: 140px;
    padding: ${({ theme }) => theme.x3spacePx / 2}px
      ${({ theme }) => theme.x1spacePx}px;
    border-left: ${({ theme, isHoldingComplete }) =>
      `4px solid  ${isHoldingComplete ? theme.color.good : 'transparent'}`};
    ${media.smDown`
      padding-left: ${({ theme }) => theme.x2spacePx}px;
    `};
  }

  &:last-child {
    border-right: 0;
  }
`;

export const TableHeadCell = styled('th')`
  ${({ theme }) => theme.typography.xSmall}
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  text-align: left;
  padding: ${({ theme }) => theme.x1spacePx}px;
  border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};

  &:first-child {
    padding-left: ${({ theme }) => theme.x2spacePx}px;
  }

  &:last-child {
    padding-right: ${({ theme }) => theme.x2spacePx}px;
  }
`;

export const StyledTable = styled('table')`
  width: 100%;
  border-spacing: 0;
  table-layout: auto;

  ${TableHeadCell} {
    &:nth-child(1) {
      ${column1CSS}
    }
    &:nth-child(2) {
      ${column2CSS}
    }
    &:nth-child(3) {
      ${column3CSS}
    }
  }
`;
